import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, withRouter, useParams, Redirect } from 'react-router-dom'
import { routes } from '../../../../constantes/routes'
import UserModal from '../UserModal'
import { swalSuccessGeneral } from '../../../../utils/swalAlert'
import { swalTitle } from '../../../../constantes/swalTitle'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import Header from '../../../header/Header'
import { usersActions } from '../../../../actions/usersActions'
import { businessunitsActions } from '../../../../actions/businessunitsActions'
import { swalMssgs } from '../../../../constantes/swalMssgs'
import validators from '../../../../utils/validationsRegEx'
import { userTypes } from '../../../../constantes/actionTypes'

const EditUserContainer = () => {
  const { id } = useParams() // toma el valor del parametro de la URL
  const history = useHistory()
  const dispatch = useDispatch()

  const updateUser = (user) => dispatch(usersActions.updateUser(user))
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())

  const userProfile = useSelector((state) => state.userProfile)
  const zones = useSelector((state) => state.zones)
  const businessunits = useSelector((state) => state.businessunits)
  const rolesList = useSelector((state) => state.rolesList)
  const colors = useSelector((state) => state.colors)
  const users = useSelector((state) => state.users)

  const [inputs, setInputs] = useState({
    id_Usuario: id,
    nombre: '',
    email: '',
    telefono: '',
    id_Rol: '',
    id_TipoZona: '',
    id_TipoColor: '',
    businessUnits: [],
  })
  const [isDisable, setIsDisable] = useState(false)
  const [modalIsOpen, setModalIsOpen] = useState(true) // Modal abierto por defecto

  const closeModal = () => {
    setModalIsOpen(false)
    history.push(routes.USERS)
  }

  useEffect(() => {
    if (userProfile.roles.isBackofficeVer) {
      getAllBusinessUnits()
    }
  }, [])

  useEffect(() => {
    if (businessunits.length > 0) {
      retrieveUser()
    }
  }, [businessunits, id])

  const retrieveUser = async () => {
    try {
      const response = await dispatch(usersActions.getUserById(id))
      const user = response && response.payload ? response.payload : null

      if (user && businessunits.length > 0) {
        // Manejar unidades de negocio según el formato que viene del backend
        const userBusinessUnits = (() => {
          if (
            user.usuariosNegocioUnidadRels &&
            Array.isArray(user.usuariosNegocioUnidadRels)
          ) {
            // Caso: datos de edición con usuariosNegocioUnidadRels (array de IDs)
            return businessunits.filter((bu) =>
              user.usuariosNegocioUnidadRels.includes(bu.id_NegocioUnidad),
            )
          } else if (
            user.id_NegocioUnidades &&
            Array.isArray(user.id_NegocioUnidades)
          ) {
            // Caso: datos con id_NegocioUnidades
            return businessunits.filter((bu) =>
              user.id_NegocioUnidades.includes(bu.id_NegocioUnidad),
            )
          }
          return []
        })()

        setInputs({
          ...user,
          businessUnits: userBusinessUnits,
        })
      } else {
        setInputs(user || {})
      }
    } catch (error) {
      console.error('Error retrieving user:', error)
    }
  }

  const getInfoUser = async (idUser) => {
    try {
      const user = await users.find((x) => x.id_Usuario.toString() === idUser)
      setInputs({ ...user })
      // Object.keys(inputs).map((input) =>
      //   setInputs((inputs) => ({ ...inputs, [input]: user[input] }))
      // );
      // setInputs({
      //   ...inputs,
      //   id_NegocioUnidades: user.usuariosNegocioUnidadRels[0]?.id_NegocioUnidades,
      // });
    } catch (error) {
      toUsers()
    }
  }

  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name
    setInputs((inputs) => ({ ...inputs, [name]: value }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      setIsDisable(true)
      // Transformar businessUnits a id_NegocioUnidades para el backend
      const { businessUnits, ...userData } = inputs
      const userDataWithBusinessUnits = {
        ...userData,
        id_NegocioUnidades: businessUnits.map((bu) => bu.id_NegocioUnidad),
      }

      const response = await updateUser(userDataWithBusinessUnits)
      if (userTypes.UPDATE_USER_SUCCESS === response.type) {
        swalSuccessGeneral(swalTitle.Actualizado, swalMssgs.UPDATE_SUCCES)
        closeModal()
        dispatch(usersActions.getUsers())
      }
    } catch (error) {
      // swalAlertError(error.payload);
      setIsDisable(false)
    }
  }

  const validateForm = () => {
    return (
      inputs.email.length > 0 &&
      validators.emailFormat(inputs.email) &&
      (inputs.telefono.length <= 0 ||
        (inputs.telefono.length > 0 &&
          validators.phoneNumberFormat(inputs.telefono))) &&
      (inputs.id_Rol.length > 0 || inputs.id_Rol !== '') &&
      inputs.nombre.length > 0 &&
      inputs.businessUnits &&
      inputs.businessUnits.length > 0
    )
  }

  const toUsers = () => {
    history.push(routes.USERS)
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <Header
            text={'Editar usuario'}
            route={() => history.goBack()}
            backBtn={false}
          />
          <UserModal
            modalIsOpen={modalIsOpen}
            closeModal={closeModal}
            inputs={inputs}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            validateForm={validateForm}
            textBtn={onSubmitText.Guardar}
            zones={zones}
            businessunits={businessunits}
            colors={colors}
            rolesList={rolesList}
            isEdit={true}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}

export default withRouter(EditUserContainer)
